module.exports = __webpack_public_path__ + "img/collectui.com.4a459232.png";